export const navlist = {
  1: {
    path: '',
    id: 1,
    name: 'index',
    showName: '自检',
    role: ['v1.window.sellTickets','manage.selfChecking.index'],
    nextLevelPath: [
      {
        path: '/index',
        role: 'v1.window.sellTickets',
        name: '首页'
      }, {
        path: '/SelfCheckList',
        role: 'manage.selfChecking.list',
        name: '自检列表'
      }
    ]
  },
  2: {
    path: '/examine',
    id: 2,
    name: 'index',
    showName: '审核',
    role: ['manage.selfChecking.examine.people', 'manage.selfChecking.examine.project'],
    nextLevelPath: [
      {
        role: 'manage.selfChecking.examine.people',
        path: '/examine/examine',
        name: '审核员管理'
      }, {
        role: 'manage.selfChecking.examine.project',
        path: '/examine/projectList',
        name: '项目列表'
      }
    ]
  },
  3: {
    path: '',
    showName: '培训',
    id: 3,
    role: ['manage.training.list'],
    nextLevelPath: [{
      role: 'manage.training.list',
      path: '/training/training',
      name: '培训列表'
    }]
  },
  4: {
    path: '',
    showName: '用户',
    id: 4,
    role: ['manage.member.list', 'manage.member.job.list', 'manage.member.store.list', 'manage.member.region.list'],
    nextLevelPath: [{
      role: 'manage.member.list',
      path: '/user/user',
      name: '用户信息'
    }, {
      role: 'manage.member.job.list',
      path: '/user/station',
      name: '岗位管理'
    }, {
      role: 'manage.member.store.list',
      path: '/user/store',
      name: '门店管理'
    }, {
      role: 'manage.member.region.list',
      path: '/user/region',
      name: '区域管理'
    }]
  },
  5: {
    path: '',
    showName: '帮助',
    id: 5,
    role: [],
    isShow: 1,//一直显示
    nextLevelPath: [],
    url: ''
  },
  6: {
    path: '',
    showName: '系统',
    id: 6,
    isShow: 1,//一直显示
    role: ['manage.system.config', 'manage.system.manage.list', ''],
    nextLevelPath: [{
      path: '/system/system',
      role: 'manage.system.config',
      name: '系统设置'
    }, {
      path: '/system/manage_list',
      role: 'manage.system.manage.list',
      name: '系统管理员'
    },
    {
      path: '/system/manage_list',
      role: 'manage.system.operateLog',
      name: '管理员日志'
    },
    {
      path: '/system/password',
      role: '',
      name: '修改密码',
      isShow: 1,
    }, {
      path: '/system/region',
      role: 'manage.system.confidentialityAgreement',
      name: '保密协议',
    },
    ]
  }
}

export const proType = function (params) {
  params = Number(params)
  switch (params) {
    case 1:
      return '日检'
    case 2:
      return '周检'
    case 3:
      return '月检'
    case 4:
      return '次检'
    default:
      break;
  }
}

export const questionTypeName = function (params) {
  params = Number(params)
  switch (params) {
    case 1:
      return '指标题'
    case 2:
      return '单选题'
    case 3:
      return '多选题'
    case 4:
      return '填空题'
    case 5:
      return '问答题'
    default:
      break;
  }
}
export const questionTypeArr = [
  {
    type: 1,
    name: '指标题',
  },
  {
    type: 2,
    name: '单选题',
  },
  {
    type: 3,
    name: '多选题',
  },
  {
    type: 4,
    name: '填空题',
  },
  {
    type: 5,
    name: '问答题',
  },
]
export const questionTypeArr2 = [
  {
    type: 1,
    name: '单选题',
  },
  {
    type: 2,
    name: '多选题',
  },
  {
    type: 3,
    name: '填空题',
  },
  {
    type: 4,
    name: '问答题',
  },
]
export const qusType1Option = [
  {
    label: '达标',
    halfOpen: 0,
    isexplain: 0,
    isphoto: 0,
    min_photo: '',
    max_photo: '',
  },
  {
    label: '不达标',
    halfOpen: 0,
    isexplain: 0,
    isphoto: 0,
    min_photo: '',
    max_photo: '',
  },
]

// export const navlist = [{
//   path: '/index',
//   id: 1,
//   name: 'index',
//   showName: '自检'
// }, {
//   path: '',
//   showName: '审核',
//   id: 2
// }, {
//   path: '',
//   showName: '培训',
//   id: 3
// }, {
//   path: '',
//   showName: '用户',
//   id: 4
// }, {
//   path: '',
//   showName: '帮助',
//   id: 5
// }, {
//   path: '',
//   showName: '系统',
//   id: 6
// }]
// import { EDITBAR, EDITADDRESS } from './index'

export const editToolConfig = {
  autoHeightEnabled: true,
  initialFrameHeight: 100,
  initialFrameWidth: "100%",
  // UEDITOR_HOME_URL: EDITADDRESS,
  // serverUrl: EDITBAR,
  enableAutoSave: true,
  toolbars: [
    [
      "fullscreen",
      "source",
      "|",
      "undo",
      "redo",
      "strikethrough",
      "justifyleft",
      "justifycenter",
      "justifyright",
      "indent",
      "forecolor",
      "backcolor",
      "directionalityltr",
      "directionalityrtl",
      "lineheight",
      "touppercase",
      "tolowercase",
      "selectall",
      "subscript",
      "superscript",
      "snapscreen",
      "formatmatch",
      'fontfamily',
      'fontsize',
      "bold",
      "underline",
      "italic",
      'removeformat',
      'simpleupload',
      'insertimage',
      'emotion'
    ],
    // [
    //   'fontfamily',
    //   'fontsize',
    //   "bold",
    //   "underline",
    //   "italic",
    //   'removeformat',
    //   'simpleupload',
    //   'insertimage',
    //   'emotion'
    // ]
  ],
}